/* unplugin-vue-components disabled */import script from "./selfDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./selfDialog.vue?vue&type=script&lang=ts&setup=true"

import "./selfDialog.vue?vue&type=style&index=0&id=52091e9a&lang=scss"

const __exports__ = script;

export default __exports__